/*
  ponte-judgeme-sob-demanda (JOT-2367, DEC-032)
  PONTE: causa externa. O app Judge.me carrega todo o seu JavaScript (dezenas de arquivos) assim que a página
  tem um widget e não oferece opção nativa de carregar só ao rolar (doc oficial "Understanding Judge.me
  loading speed": otimizações automáticas, sem configuração).
  Issue: JOT-2367. Dono: coordenador da Loja NFR.
  Morre quando o Judge.me oferecer carregamento sob demanda nativo. Revisar em 22/01/2027 (changelog do app);
  no dia, remover este arquivo, o <script> em layout/theme.liquid e o marcador data-jdgm-sentinel da seção.
  O que faz: tira os widgets do documento até a seção de avaliações (ou um selo de card) chegar perto
  da tela; só então devolve os widgets e roda de novo o loader.js do próprio app (endereço lido da página,
  nunca fixo). Carregado com defer ANTES de {{ content_for_header }}, para rodar antes do loader.js do app.
*/
(function () {
  if (window.Shopify && window.Shopify.designMode) return;
  if (!('IntersectionObserver' in window)) return;

  var WIDGETS = '.jdgm-widget, .jdgm-review-widget, #judgeme_product_reviews, .jdgm-preview-badge, .jdgm-all-reviews-page';
  var loc = window.location;
  // Links de e-mail de avaliação abrem o formulário na hora: sem adiar.
  if (/^#judgeme/.test(loc.hash) || /judgeme_(token|review_uuid|dynamic_form|follow_up_token|upload_pictures|pre_verified)/.test(loc.search)) return;

  var found = document.querySelectorAll(WIDGETS);
  var held = [];
  var watch = [];
  Array.prototype.forEach.call(found, function (node) {
    var parent = node.parentElement;
    if (!parent || parent.closest(WIDGETS)) return;
    var marker = document.createComment('jdgm');
    parent.replaceChild(marker, node);
    held.push({ marker: marker, node: node });
    watch.push(parent);
  });
  if (!held.length) return;
  Array.prototype.forEach.call(document.querySelectorAll('[data-jdgm-sentinel]'), function (el) { watch.push(el); });

  var booted = false;
  function boot() {
    if (booted) return;
    booted = true;
    observer.disconnect();
    held.forEach(function (h) { h.marker.parentNode.replaceChild(h.node, h.marker); });
    var jdgm = window.jdgm;
    var loader = document.querySelector('script[src*="judgeme"][src*="loader.js"]');
    if (!jdgm || !loader) return;
    // O loader do app só varre a página uma vez; liberar a trava e repor o mesmo arquivo faz a varredura agora.
    jdgm._loaderExecuted = false;
    var again = document.createElement('script');
    again.src = loader.src;
    again.async = true;
    document.head.appendChild(again);
  }
  function go() {
    // Espera o loader original fazer a varredura dele (sem widgets) antes de repor.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', go, { once: true });
      return;
    }
    setTimeout(boot, 0);
  }

  var observer = new IntersectionObserver(function (entries) {
    if (entries.some(function (e) { return e.isIntersecting; })) go();
  }, { rootMargin: '300px 0px' });
  watch.forEach(function (el) { observer.observe(el); });
})();
